<template lang="pug">
#filing-guidelines.filing-guidelines
  template(v-if="error")
    .filing-guidelines__error
      h3 {{ errorMessage }}
  template(v-else)
    template(v-if="!loading && config")
      h1.filing-guidelines__heading(v-if="config && config.title") {{ config.title }}
      .filing-guidelines__criteria
        p.filing-guidelines__label {{ config.criteriaHeading }}
        Dropdown(
          v-for="criteria, index in criterias"
          @clear-option="clearCriteria"
          @select-option="selectCriteria"
          :key="criteria.reference"
          :data="criteria"
          :multi="false"
          :index="index",
          :total="criterias.length")
      template(v-if="noResults")
        .filing-guidelines__error
          h3 {{ noResultsMessage }}
      template(v-else)
        Guidelines(v-if="hasResults")
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Dropdown from "@/global/components/Dropdown.vue";
import Guidelines from "./components/GuidelineResults.vue";

export default {
  name: "FilingGuidelines",
  components: {
    Dropdown,
    Guidelines
  },
  data: function () {
    return {
      selectedDomicile: null,
      selectedProfitType: null,
      selectedEntityType: null,
      selectedState: null,
    };
  },
  computed: {
    ...mapGetters([
      "config",
      "loading",
      "results",
      "noResults",
      "noResultsMessage",
      "error",
      "errorMessage"
    ]),
    criterias() {
      return [
        {
          placeholder: this.config.statePlaceholder,
          reference: 'selectedState',
          options: this.config.stateOptions
        },
        {
          placeholder: this.config.domicileTypePlaceholder,
          reference: 'selectedDomicile',
          options: this.config.domicileTypeOptions
        },
        {
          placeholder: this.config.profitTypePlaceholder,
          reference: 'selectedProfitType',
          options: this.config.profitTypeOptions
        },
        {
          placeholder: this.config.entityTypePlaceholder,
          reference: 'selectedEntityType',
          options: this.config.entityTypeOptions
        }
      ]
    },
    canSubmit() {
      return this.selectedDomicile && this.selectedProfitType && this.selectedEntityType && this.selectedState;
    },
    hasResults() {
      return this.canSubmit && this.results;
    }
  },
  methods: {
    ...mapActions(["loadConfig", "getResults", "clearResults"]),
    clearCriteria(reference) {
      this[reference] = null;
      this.clearResults();
    },
    selectCriteria([reference, val]) {
      this[reference] = val;
      if (this.canSubmit) this.submit();
    },
    submit() {
      this.getResults({
        url: this.$root.apiSearch,
        payload: {
          stateId: this.selectedState.id,
          profitType: this.selectedProfitType.id,
          entityType: this.selectedEntityType.id,
          domicileType: this.selectedDomicile.id,
        }
      });
    }
  },
  async created() {
    await this.loadConfig({
      url: this.$root.apiConfig,
      nodeAlias: this.$root.nodeAlias,
      error: this.$root.error,
      noResultsMessage: this.$root.apiNoResultsMessage,
    });
  }
};
</script>

<style scoped lang="scss">
.filing-guidelines {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 0;
  min-height: 50vh;

  &__error {
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ff0000;

    h3 {
      font-size: 2.5rem;
    }
  }

  &__heading {
    text-transform: uppercase;
    font-size: 1.5rem;
    color: $darkGray;
    letter-spacing: 1.6px;
  }

  &__criteria {
    display: grid;
    grid-template-columns: auto repeat(4, minmax(0, 1fr)) auto;
    gap: 1rem;
    padding: 2rem 0;
    border: 1px solid $orange;
    border-left: 0;
    border-right: 0;

    @include mqdn(lg) {
      display: flex;
      flex-direction: column;
    }
  }

  &__label {
    grid-area: span 1 / span 1;
    text-transform: uppercase;
    margin: auto 0;
    color: $darkGray;
    letter-spacing: 1.6px;
  }

  &__submit {
    grid-area: span 1 / span 1;
    font-size: 0.875rem;

    &:disabled {
      pointer-events: none;
      filter: grayscale(1);
      opacity: 0.7;
    }
  }
}
</style>
